module.exports = __webpack_public_path__ + "static/media/001-bell.580b9bc9.svg";